// export const BASE_URL = "http://" + window.location.hostname + "/core/api.php";
export const BASE_URL = "https://" + window.location.hostname + "/core/api.php";
console.log(BASE_URL);
